import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=47ad7b38&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"
import style0 from "./registration.vue?vue&type=style&index=0&id=47ad7b38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad7b38",
  null
  
)

component.options.__file = "registration.vue"
export default component.exports